import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Grid, Row, Column } from '@xingternal/malt-grid';

import LegalFooter from '../LegalFooter';
import LanguageSwitcher from '../LanguageSwitcher';
import QuicklinksSection from './QuicklinksSection';
import { propTypes } from './footer-proptypes';
import styles from './index.css';

const Footer = ({ className, collapsible, links }) => {
  const footerClasses = classNames(className, styles.footer, {
    [styles.inSidenav]: collapsible,
  });

  const { aboutLinks, appLinks, offerLinks } = links;

  return (
    <footer className={footerClasses}>
      <div className={styles.footerRow}>
        <div className={classNames(styles.quickLinks, styles.innerFooter)}>
          <Grid type="standard" outermost>
            {collapsible ? (
              <div className={styles.padder}>
                <QuicklinksSection
                  title="VERTICAL_NAVIGATION_FOOTER_ABOUT_XING"
                  links={aboutLinks}
                  collapsible
                />
                <QuicklinksSection
                  title="VERTICAL_NAVIGATION_FOOTER_USEFUL"
                  links={appLinks}
                  collapsible
                />
                <QuicklinksSection
                  title="VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_AND_PARTNER"
                  links={offerLinks}
                  collapsible
                />
                <hr className={styles.hr} />
                <LanguageSwitcher />
                <hr className={styles.hr} />
                <LegalFooter vertical onGreen />
              </div>
            ) : (
              <Row outermost>
                <Column size={4}>
                  <QuicklinksSection
                    title="VERTICAL_NAVIGATION_FOOTER_ABOUT_XING"
                    links={aboutLinks}
                  />
                </Column>
                <Column size={4}>
                  <QuicklinksSection
                    title="VERTICAL_NAVIGATION_FOOTER_USEFUL"
                    links={appLinks}
                  />
                </Column>
                <Column size={4}>
                  <QuicklinksSection
                    title="VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_AND_PARTNER"
                    links={offerLinks}
                  />
                </Column>
              </Row>
            )}
          </Grid>
        </div>
      </div>

      {!collapsible && (
        <div className={classNames(styles.footerRow, styles.legal)}>
          <div className={styles.innerFooter}>
            <LegalFooter onGreen />
            <LanguageSwitcher />
          </div>
        </div>
      )}

      <div className={classNames(styles.footerRow, styles.copyright)}>
        <div className={styles.innerFooter}>
          <FormattedMessage
            id={'MALT_FOOTER_COPYRIGHT_API'}
            values={{ siteoperator: 'New Work SE' }}
          >
            {text => text}
          </FormattedMessage>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

Footer.propTypes = propTypes;

export default Footer;
